import { Object3D, Euler, Quaternion, Vector3, VSMShadowMap, PCFSoftShadowMap, SpotLight, Box3, RGBADepthPacking, MeshDepthMaterial, MeshStandardMaterial } from 'three';

export class Model extends Object3D{
	constructor(viewer, modelName, data){
		super();
		this.viewer 	= viewer;
		this.modelName 	= modelName;
		this.data   	= data;

		this.layoutWrapper 	= new Object3D();
		this.wrapper 	  	= new Object3D();

		this.add(this.layoutWrapper);
		this.layoutWrapper.add(this.wrapper);

		this.loaded = false;
		this.load();
	}

	get model(){
		return this._model;
	}

	async load(){
		this._model = await this.viewer.load(`/storage/models/${this.modelName}`);

		this.wrapper.add(this._model);
		this.loadComplete();
	}

	loadComplete(){
		this.loaded = true;

		this.wrapper.traverse((obj) => {
			obj.receiveShadow = true;
			obj.castShadow = true;

			if(obj.isMesh){
				if(obj.material){

					obj.material.envMapIntensity = 0.5;

					if(obj.material.name.toLowerCase().startsWith('meubl')){
						obj.material.normalMap = null;
					}
					if(obj.material.name == "glass_mat"){
						obj.material.roughness = 0;
						obj.material.normalMap = null;
						obj.customDepthMaterial = new MeshDepthMaterial( {
							depthPacking: RGBADepthPacking,
							map: obj.material.map,
							alphaTest: 0.5
						});
					}
				}
			}
		})
		this.layout();
		this.dispatchEvent({type:'loaded'});
	}

	layout(){
	}

	freeMemory = () => {
		this.traverse((item) => {
			if(item.isMesh && item.material){

				if(item.material instanceof MeshStandardMaterial){
					if(item.material.alphaMap) item.material.alphaMap.dispose();
					if(item.material.aoMap) item.material.aoMap.dispose();
					if(item.material.bumpMap) item.material.bumpMap.dispose();
					if(item.material.displacementMap) item.material.displacementMap.dispose();
					if(item.material.emissiveMap) item.material.emissiveMap.dispose();
					if(item.material.lightMap) item.material.lightMap.dispose();
					if(item.material.map) item.material.map.dispose();
					if(item.material.metalnessMap) item.material.metalnessMap.dispose();
					if(item.material.normalMap) item.material.normalMap.dispose();
					if(item.material.roughnessMap) item.material.roughnessMap.dispose();
				}

				item.material.dispose();
				item.geometry.dispose();
			}
		})
	}
}